import { createRequest } from "helpers/tools";

export const getTrackerReports = async (id, date) => {
    let form = {
        tracker_id: id,
        days: parseInt(date),
    };
    return await createRequest({
        suffix: `trackers/reports/events`,
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const fetchEventMatchQualityAsync = async (pixelId) => {
    return await createRequest({
        suffix: `trackers/reports/event_match_quality?pixel_id=${pixelId}`,
        method: "get",
        handleError: false,
    });
};
export const fetchEventMatchQualityEventsAsync = async (pixelId, event) => {
    return await createRequest({
        suffix: `trackers/reports/event_match_quality?pixel_id=${pixelId}&event_name=${event}`,
        method: "get",
        handleError: false,
    });
};
export const getAllTracker = async () => {
    return await createRequest({
        suffix: `user/dashboard-all-events`,
        method: "get",
        handleError: false,
    });
};
